import axios from 'axios';
import moment from 'moment';
import 'rxjs';
import { browserHistory } from 'react-router';
import { change, initialize, arrayRemove, arrayInsert } from 'redux-form';
import { resetCurrentSalesOrder, selectSalesOrder } from './sales_actions';
import { toFromDates, convertUtcDate, getFromToDates } from '../components/Common/cleanDates';

import {
  REQUEST_PURCHASE_ORDERS,
  FETCH_PURCHASE_ORDERS_SUCCESS,
  FETCH_PURCHASE_ORDERS_FAILURE,
  SELECT_PURCHASE_ORDER,
  RESET_CURRENT_PURCHASE_ORDER,
  REQUEST_PURCHASE_ORDER_DETAIL,
  FETCH_PURCHASE_ORDER_DETAIL_SUCCESS,
  FETCH_PURCHASE_ORDER_DETAIL_FAILURE,
  REQUEST_CREATING_PURCHASE_ORDER,
  CREATE_PURCHASE_ORDER_SUCCESS,
  CREATE_PURCHASE_ORDER_FAILURE,
  REQUEST_EDITING_PURCHASE_ORDER,
  EDIT_PURCHASE_ORDER_SUCCESS,
  EDIT_PURCHASE_ORDER_FAILURE,
  REQUEST_PURCHASE_ORDERS_NOT_RECEIVED,
  FETCH_PURCHASE_ORDERS_NOT_RECEIVED_SUCCESS,
  FETCH_PURCHASE_ORDERS_NOT_RECEIVED_FAILURE,
  REQUEST_TOTAL_PURCHASES,
  FETCH_TOTAL_PURCHASES_SUCCESS,
  FETCH_TOTAL_PURCHASES_FAILURE,
  REQUEST_TODAYS_INCOMING_ORDERS,
  FETCH_TODAYS_INCOMING_ORDERS_SUCCESS,
  FETCH_TODAYS_INCOMING_ORDERS_FAILURE,
  COPY_PURCHASE_ORDER,
  COPY_PURCHASE_ORDER_SUCCESS,
  COPY_PURCHASE_ORDER_FAILURE,
  REQUEST_PRINT_PURCHASE_ORDER,
  PRINT_PURCHASE_ORDER_SUCCESS,
  REQUEST_PURCHASE_ORDER_PERFORMANCE,
  FETCH_PURCHASE_ORDER_PERFORMANCE_SUCCESS,
  FETCH_PURCHASE_ORDER_PERFORMANCE_FAILURE,
  REQUEST_PURCHASE_MANAGER_INFO,
  FETCH_PURCHASE_MANAGER_INFO_SUCCESS,
  FETCH_PURCHASE_MANAGER_INFO_FAILURE,
  REQUEST_LAST_MONTH_PERFORMANCE,
  FETCH_LAST_MONTH_PERFORMANCE_SUCCESS,
  FETCH_LAST_MONTH_PERFORMANCE_FAILURE,
  PRINT_PURCHASE_ORDER_FAILURE,
  REQUEST_DELETE_PURCHASE_ORDER,
  DELETE_PURCHASE_ORDER_SUCCESS,
  DELETE_PURCHASE_ORDER_FAILURE,
  REQUEST_PURCHASERS_PERFORMANCE,
  FETCH_PURCHASERS_PERFORMANCE_SUCCESS,
  FETCH_PURCHASERS_PERFORMANCE_FAILURE,
  REQUEST_PRESIDENT_DASH_INFO,
  FETCH_PRESIDENT_DASH_INFO_SUCCESS,
  FETCH_PRESIDENT_DASH_INFO_FAILURE,
  REQUEST_OVERALL_PURCHASE_PERFORMANCE,
  FETCH_OVERALL_PURCHASE_PERFORMANCE_SUCCESS,
  FETCH_OVERALL_PURCHASE_PERFORMANCE_FAILURE,
  REQUEST_INCIDENT_REPORT,
  FETCH_INCIDENT_REPORT_SUCCESS,
  FETCH_INCIDENT_REPORT_FAILURE,
  REQUEST_PURCHASE_ORDER_LIST,
  FETCH_PURCHASE_ORDER_LIST_SUCCESS,
  FETCH_PURCHASE_ORDER_LIST_FAILURE,
  SET_PURCHASE_ORDERS_FILTER,
  REQUEST_PURCHASING_PERFORMANCE,
  FETCH_PURCHASING_PERFORMANCE_SUCCESS,
  FETCH_PURCHASING_PERFORMANCE_FAILURE,
  REQUEST_PRICE_ADJUSTMENT,
  FETCH_PRICE_ADJUSTMENT_SUCCESS,
  FETCH_PRICE_ADJUSTMENT_FAILURE,
  CREATE_PRICE_ADJUSTMENT,
  CREATE_PRICE_ADJUSTMENT_SUCCESS,
  CREATE_PRICE_ADJUSTMENT_FAILURE,
  REQUEST_PURCHASE_PIVOT_CHART_ORDERS,
  FETCH_PURCHASE_PIVOT_CHART_ORDERS_SUCCESS,
  FETCH_PURCHASE_PIVOT_CHART_ORDERS_FAILURE,
  REQUEST_PURCHASE_PIVOT_CHARTS,
  FETCH_PURCHASE_PIVOT_CHARTS_SUCCESS,
  FETCH_PURCHASE_PIVOT_CHARTS_FAILURE,
  REQUEST_PURCHASE_PIVOT_CHARTS_DETAIL,
  FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_SUCCESS,
  FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_FAILURE,
  SET_PURCHASE_PIVOT_ID,
  RESET_PURCHASE_PIVOT_CHARTS,
  CREATE_PURCHASE_PIVOT_CHART,
  CREATE_PURCHASE_PIVOT_CHART_SUCCESS,
  CREATE_PURCHASE_PIVOT_CHART_FAILURE,
  DUPLICATE_PURCHASE_PIVOT_CHART,
  DUPLICATE_PURCHASE_PIVOT_CHART_SUCCESS,
  DUPLICATE_PURCHASE_PIVOT_CHART_FAILURE,
  CLEAR_DUPLICATED_PURCHASE_PIVOT_CHART,
  REQUEST_PURCHASING_REFERENCE,
  FETCH_PURCHASING_REFERENCE_SUCCESS,
  FETCH_PURCHASING_REFERENCE_FAILURE,
  FETCH_PURCHASE_PAYMENT_NOT_PAID_FAILURE,
  FETCH_PURCHASE_PAYMENT_NOT_PAID_SUCCESS,
  REQUEST_PURCHASE_PAYMENT_NOT_PAID,
  REQUEST_PURCHASING_PERFORMANCE_BY_PRODUCT,
  FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_SUCCESS,
  FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_FAILURE,
  REQUEST_PURCHASE_PRODUCT_BY_ID,
  FETCH_PURCHASE_PRODUCT_BY_ID_SUCCESS,
  FETCH_PURCHASE_PRODUCT_BY_ID_FAILURE,
  MERGE_PURCHASE_ORDERS_LOADING,
  MERGE_PURCHASE_ORDERS_SUCCESS,
  MERGE_PURCHASE_ORDERS_ERROR
} from './type';

import {
  PURCHASE_URL,
  PURCHASE_ORDERS_URL,
  PURCHASE_ORDERS_NOT_RECEIVED_URL,
  TOTAL_PURCHASES_URL,
  INCOMING_ORDERS_BY_DATE_URL,
  PURCHASE_ORDER_PERFORMANCE_URL,
  PURCHASE_MANAGER_INFO_URL,
  LAST_MONTH_PERFORMANCE_URL,
  PRESIDENT_DASH_INFO_URL,
  OVERALL_PURCHASE_PERFORMANCE_URL,
  INCIDENT_REPORT_URL,
  WAREHOUSES_URL,
  PURCHASE_ORDER_PRODUCT_BY_ID_URL,
  MERGE_PURCHASE_ORDERS_API,
  APPROVE_PENDING_PO_URL,
  PO_SET_TO_FACTORY_URL,
  PO_SET_TO_PORT_URL,
  PO_SET_TO_TRUCK_URL,
  SALES_INVOICE_EMAIL_LAP,
  DASHBOARD_PO_PAST_URL,
  ROOT_URL_V2,
  PURCHASE_LONGCODE_PRINT_URL,
} from './url';
import { DEFAULT_ERROR } from '../components/Common/constants';
import {
  ROOT_API_URL, ROOT_URL, isGGI, isLAP, isSV, isEKC, isLMH, isSDR, isCRW, isSC
} from './root_url';

export function fetchPurchaseOrders() {
  return (dispatch) => {
    dispatch(requestPurchaseOrders());
    return axios.get(
      PURCHASE_ORDERS_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPurchaseOrdersSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPurchaseOrdersFailure(err));                       
        }
      });
  };
}

export function requestPurchaseOrders() {
  return {
    type: REQUEST_PURCHASE_ORDERS,
  };
}

export function fetchPurchaseOrdersSuccess(purchaseOrders) {
  return {
    type: FETCH_PURCHASE_ORDERS_SUCCESS,
    payload: purchaseOrders,
  };
}

export function fetchPurchaseOrdersFailure(error) {
  return {
    type: FETCH_PURCHASE_ORDERS_FAILURE,
    payload: error,
  };
}

export function fetchPurchaseOrdersByDate(postingDateGT, postingDateLT, days) {
  const dates = toFromDates(days, postingDateGT, postingDateLT);
  return (dispatch) => {
    dispatch(requestPurchaseOrders());
    return axios.get(
      `${PURCHASE_URL}search/?OrderDate__gte=${dates.fromDate
      }&OrderDate__lte=${dates.toDate}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPurchaseOrdersSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPurchaseOrdersFailure(err));                       
        }
      });
  };
}

export function selectPurchaseOrder(purchaseOrder) {
  return {
    type: SELECT_PURCHASE_ORDER,
    payload: purchaseOrder,
  };
}


export function resetCurrentPurchaseOrder() {
  return {
    type: RESET_CURRENT_PURCHASE_ORDER,
  };
}

// Fetch the detail page.

export function fetchPurchaseOrderDetail(purchaseOrder_id) {
  return (dispatch) => {
    dispatch(requestPurchaseOrderDetail());
    return axios.get(
      PURCHASE_ORDERS_URL + purchaseOrder_id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPurchaseOrderDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPurchaseOrderDetailFailure(err));                       
        }
      });
  };
}

export function requestPurchaseOrderDetail() {
  return {
    type: REQUEST_PURCHASE_ORDER_DETAIL,
  };
}

export function fetchPurchaseOrderDetailSuccess(purchaseOrderDetail) {
  purchaseOrderDetail = purchaseOrderDetail.data;
  // The date data fetched is in the form of string, which needs to be modified into Date type
  if (purchaseOrderDetail.OrderDate) purchaseOrderDetail.OrderDate = convertUtcDate(purchaseOrderDetail.OrderDate);
  if (purchaseOrderDetail.ETADate) purchaseOrderDetail.ETADate = convertUtcDate(purchaseOrderDetail.ETADate);
  if (purchaseOrderDetail.ReceivedDate) purchaseOrderDetail.ReceivedDate = convertUtcDate(purchaseOrderDetail.ReceivedDate);
  return {
    type: FETCH_PURCHASE_ORDER_DETAIL_SUCCESS,
    payload: purchaseOrderDetail,
  };
}

export function fetchPurchaseOrderDetailFailure(error) {
  return {
    type: FETCH_PURCHASE_ORDER_DETAIL_FAILURE,
    payload: error,
  };
}

export function createPurchaseOrder({
  // Purchase_Order_Line,
  OrderDate,
  ETADate,
  ReceivedDate,
  NoteToVendor,
  ReleaseInformation,
  CarryType,
  Discount,
  ShippingCost,
  HandlingCost,
  PurchaseStatus,
  PaymentTerm_id,
  MiscCost,
  MiscNote,
  PriceAdjustment,
  PaymentStatus,
  ConvertItemPrice,
  IsDropship,
  Vendor_id,
  Pickup_VendorDetail_id,
  Deliver_Warehouse_id,
  DispatchMethod_id,
  DispatchOutSourceContact_id,
  Purchaser_User_id,
  Modifier_User_id,
  ShippingMethod,
  TaxValue,
}, Purchase_Order_Line, AttachedFile, TaxRate, CRV, FinalNetWeight, FinalShippingWeight, TotalPrice, FinalPrice) {
  Purchase_Order_Line.map((product) => {
    if (product.Product_id) { product.Product_id = product.Product_id.value || product.Product_id; }
  });
  if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
  if (PaymentStatus) PaymentStatus = PaymentStatus.value || PaymentStatus;
  if (Pickup_VendorDetail_id) Pickup_VendorDetail_id = Pickup_VendorDetail_id.value || Pickup_VendorDetail_id;
  if (CarryType) CarryType = CarryType.value || CarryType;
  if (PaymentTerm_id) PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
  if (Deliver_Warehouse_id) Deliver_Warehouse_id = Deliver_Warehouse_id.value || Deliver_Warehouse_id;
  if (ShippingMethod) ShippingMethod = ShippingMethod.value || ShippingMethod;
  if (OrderDate == null) OrderDate = convertUtcDate();
  if (ETADate == null) ETADate = convertUtcDate();
  let TaxAmount = 0;
  if (TaxValue) TaxAmount = TaxValue.value || TaxValue;
  return (dispatch) => {
    dispatch({ type: REQUEST_CREATING_PURCHASE_ORDER });
    axios.post(
      PURCHASE_ORDERS_URL,
      {
        Purchase_Order_Line,
        OrderDate,
        ETADate,
        ReceivedDate,
        FinalNetWeight,
        FinalShippingWeight,
        TotalPrice,
        NoteToVendor,
        ReleaseInformation,
        CarryType,
        Discount,
        ShippingCost,
        HandlingCost,
        PriceAdjustment,
        MiscCost,
        MiscNote,
        TaxRate,
        TaxAmount,
        PurchaseStatus,
        PaymentTerm_id,
        PaymentStatus,
        FinalPrice,
        ConvertItemPrice,
        IsDropship,
        Vendor_id,
        Pickup_VendorDetail_id,
        Deliver_Warehouse_id,
        DispatchMethod_id,
        DispatchOutSourceContact_id,
        Purchaser_User_id,
        Modifier_User_id,
        AttachedFile,
        ShippingMethod,
        CRV,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(createPurchaseOrderSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(createPurchaseOrderFailure(err));                       
        }
      });
  };
}

export function createPurchaseOrderSuccess(response) {
  return {
    type: CREATE_PURCHASE_ORDER_SUCCESS,
    payload: response,
  };
}

export function createPurchaseOrderFailure(error) {
  return {
    type: CREATE_PURCHASE_ORDER_FAILURE,
    payload: error,
  };
}

export function createDropship(
  Deliver_Customer_id,
  Deliver_CustomerDetail_id,
  Customer_PaymentTerm_id,
  {
    OrderDate,
    ETADate,
    ReceivedDate,
    NoteToVendor,
    ReleaseInformation,
    CarryType,
    Discount,
    ShippingCost,
    HandlingCost,
    PurchaseStatus,
    MiscCost,
    MiscNote,
    TaxRate,
    PaymentStatus,
    PaymentTerm_id,
    ConvertItemPrice,
    IsDropship,
    Vendor_id,
    Pickup_VendorDetail_id,
    Deliver_Warehouse_id,
    DispatchMethod_id,
    DispatchOutSourceContact_id,
    Purchaser_User_id,
    Modifier_User_id,
  }, Purchase_Order_Line, FinalNetWeight, FinalShippingWeight, TotalPrice, FinalPrice,
) {
  Purchase_Order_Line.map((product) => {
    if (product.Product_id) { product.Product_id = product.Product_id.value || product.Product_id; }
  });
  if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
  if (PaymentStatus) PaymentStatus = PaymentStatus.value || PaymentStatus;
  if (Pickup_VendorDetail_id) Pickup_VendorDetail_id = Pickup_VendorDetail_id.value || Pickup_VendorDetail_id;
  if (CarryType) CarryType = CarryType.value || CarryType;
  if (PaymentTerm_id) PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
  if (Deliver_Warehouse_id) Deliver_Warehouse_id = Deliver_Warehouse_id.value || Deliver_Warehouse_id;
  if (OrderDate == null) OrderDate = convertUtcDate();
  if (ETADate == null) ETADate = convertUtcDate();
  return (dispatch) => {
    dispatch({ type: REQUEST_CREATING_PURCHASE_ORDER });
    axios.post(
      PURCHASE_ORDERS_URL,
      {
        Purchase_Order_Line,
        OrderDate,
        ETADate,
        ReceivedDate,
        FinalNetWeight,
        FinalShippingWeight,
        TotalPrice,
        NoteToVendor,
        ReleaseInformation,
        CarryType,
        Discount,
        ShippingCost,
        HandlingCost,
        MiscCost,
        MiscNote,
        TaxRate,
        PurchaseStatus,
        PaymentStatus,
        PaymentTerm_id,
        FinalPrice,
        ConvertItemPrice,
        IsDropship,
        Vendor_id,
        Pickup_VendorDetail_id,
        Deliver_Warehouse_id,
        DispatchMethod_id,
        DispatchOutSourceContact_id,
        Purchaser_User_id,
        Modifier_User_id,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        copyPurchaseOrder(dispatch, response.data.PurchaseOrder_id, Deliver_Customer_id, Deliver_CustomerDetail_id, Customer_PaymentTerm_id);
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(createDropshipFailure(err));                       
        }
      });
  };
}

export function copyPurchaseOrder(dispatch, PurchaseOrder_id, Deliver_Customer_id, Deliver_CustomerDetail_id, PaymentTerm_id) {
  axios.post(
    `${PURCHASE_URL}dropship/${PurchaseOrder_id}`,
    {
      Deliver_Customer_id,
      Deliver_CustomerDetail_id,
      PaymentTerm_id,
    },
    {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    },
  )
    .then((response) => {
      resetCurrentSalesOrder();
      dispatch(selectSalesOrder(response.data));
      browserHistory.push(`/salesOrders/${response.data.SalesOrder_id}`);
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(createDropshipFailure(err));                     
      }
    });
}

export function copyPurchaseOrderSuccess() {
  return {
    type: COPY_PURCHASE_ORDER_SUCCESS,
  };
}

export function copyPurchaseOrderFailure(error) {
  return {
    type: COPY_PURCHASE_ORDER_FAILURE,
    payload: error,
  };
}

export function createDropshipSuccess() {
  return {
    type: CREATE_PURCHASE_ORDER_SUCCESS,
  };
}

export function createDropshipFailure(error) {
  return {
    type: CREATE_PURCHASE_ORDER_FAILURE,
    payload: error,
  };
}

export function editPurchaseOrder({
  PurchaseOrder_id,
  Name,
  OrderDate,
  ETADate,
  ReceivedDate,
  NoteToVendor,
  ReleaseInformation,
  CarryType,
  Discount,
  ShippingCost,
  HandlingCost,
  PriceAdjustment,
  MiscCost,
  MiscNote,
  PaymentStatus,
  PaymentTerm_id,
  PurchaseStatus,
  ConvertItemPrice,
  IsDropship,
  Vendor_id,
  Pickup_VendorDetail_id,
  Deliver_Warehouse_id,
  DispatchMethod_id,
  DispatchOutSourceContact_id,
  Purchaser_User_id,
  Modifier_User_id,
  InStock,
  Ordered,
  PreSale,
  Salebale,
  ShippingMethod,
  TaxValue,
}, Purchase_Order_Line, AttachedFile, TaxRate, CRV, FinalNetWeight, FinalShippingWeight, TotalPrice, FinalPrice) {
  Purchase_Order_Line.map((product) => {
    if (product.Product_id) { product.Product_id = product.Product_id.value || product.Product_id; }
  });
  if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
  if (PaymentStatus) PaymentStatus = PaymentStatus.value || PaymentStatus;
  if (PaymentTerm_id) PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
  if (Pickup_VendorDetail_id) Pickup_VendorDetail_id = Pickup_VendorDetail_id.value || Pickup_VendorDetail_id;
  if (CarryType) CarryType = CarryType.value || CarryType || 'Dry';
  if (Deliver_Warehouse_id) Deliver_Warehouse_id = Deliver_Warehouse_id.value || Deliver_Warehouse_id;
  if (ShippingMethod) ShippingMethod = ShippingMethod.value || ShippingMethod;
  let TaxAmount = 0;
  if (TaxValue) TaxAmount = TaxValue.value || TaxValue;
  return (dispatch) => {
    dispatch({ type: REQUEST_EDITING_PURCHASE_ORDER });
    axios.put(
      (PURCHASE_ORDERS_URL + PurchaseOrder_id),
      {
        Purchase_Order_Line,
        Name,
        OrderDate,
        ETADate,
        ReceivedDate,
        FinalNetWeight,
        FinalShippingWeight,
        TotalPrice,
        NoteToVendor,
        ReleaseInformation,
        CarryType,
        Discount,
        ShippingCost,
        HandlingCost,
        PriceAdjustment,
        MiscCost,
        MiscNote,
        TaxRate,
        TaxAmount,
        PurchaseStatus,
        PaymentStatus,
        PaymentTerm_id,
        FinalPrice,
        ConvertItemPrice,
        IsDropship,
        Vendor_id,
        Pickup_VendorDetail_id,
        Deliver_Warehouse_id,
        DispatchMethod_id,
        DispatchOutSourceContact_id,
        Purchaser_User_id,
        Modifier_User_id,
        AttachedFile,
        ShippingMethod,
        CRV,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(editPurchaseOrderSuccess());
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(editPurchaseOrderFailure(err));                       
        }
      });
  };
}

export function editPurchaseOrderSuccess() {
  return {
    type: EDIT_PURCHASE_ORDER_SUCCESS,
  };
}

export function editPurchaseOrderFailure(error) {
  return {
    type: EDIT_PURCHASE_ORDER_FAILURE,
    payload: error,
  };
}

export function fetchPurchaseOrdersNotReceived() {
  return (dispatch) => {
    dispatch(requestPurchaseOrdersNotReceived());
    return axios.get(
      PURCHASE_ORDERS_NOT_RECEIVED_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPurchaseOrdersNotReceivedSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPurchaseOrdersNotReceivedFailure(err));                       
        }
      });
  };
}

export function requestPurchaseOrdersNotReceived() {
  return {
    type: REQUEST_PURCHASE_ORDERS_NOT_RECEIVED,
  };
}

export function fetchPurchaseOrdersNotReceivedSuccess(purchaseOrders) {
  return {
    type: FETCH_PURCHASE_ORDERS_NOT_RECEIVED_SUCCESS,
    payload: purchaseOrders,
  };
}

export function fetchPurchaseOrdersNotReceivedFailure(error) {
  return {
    type: FETCH_PURCHASE_ORDERS_NOT_RECEIVED_FAILURE,
    payload: error,
  };
}

export function fetchTotalPurchases() {
  return (dispatch) => {
    dispatch(requestTotalPurchases());
    return axios.get(
      TOTAL_PURCHASES_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchTotalPurchasesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchTotalPurchasesFailure(err));                       
        }
      });
  };
}

export function requestTotalPurchases() {
  return {
    type: REQUEST_TOTAL_PURCHASES,
  };
}

export function fetchTotalPurchasesSuccess(totalPurchases) {
  return {
    type: FETCH_TOTAL_PURCHASES_SUCCESS,
    payload: totalPurchases,
  };
}

export function fetchTotalPurchasesFailure(error) {
  return {
    type: FETCH_TOTAL_PURCHASES_FAILURE,
    payload: error,
  };
}

export function fetchTodaysIncomingOrders() {
  return (dispatch) => {
    dispatch(requestTodaysIncomingOrders());
    return axios.get(
      INCOMING_ORDERS_BY_DATE_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchTodaysIncomingOrdersSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchTodaysIncomingOrdersFailure(err));                       
        }
      });
  };
}

export function requestTodaysIncomingOrders() {
  return {
    type: REQUEST_TODAYS_INCOMING_ORDERS,
  };
}

export function fetchTodaysIncomingOrdersSuccess(orders) {
  return {
    type: FETCH_TODAYS_INCOMING_ORDERS_SUCCESS,
    payload: orders,
  };
}

export function fetchTodaysIncomingOrdersFailure(error) {
  return {
    type: FETCH_TODAYS_INCOMING_ORDERS_FAILURE,
    payload: error,
  };
}

export function fetchIncomingOrdersByDate({ fromDate, toDate, selectedCompany, selectedWarehouse, isPastPo = false, order='ETADate' }) {
  return (dispatch) => {
    dispatch(requestTodaysIncomingOrders());
    let url = INCOMING_ORDERS_BY_DATE_URL;
    if(isGGI && selectedWarehouse && selectedWarehouse != undefined && selectedWarehouse != null) {
      url = INCOMING_ORDERS_BY_DATE_URL + selectedWarehouse;
    }
    let data = isGGI ? {
      start_date: fromDate,
      end_date: toDate,
      Company_id: selectedCompany,
    } : {
      start_date: fromDate,
      end_date: toDate,
    }
    if(isLAP) {
      let timeZone = new Date().getTimezoneOffset();
      if(isPastPo) {
        url = DASHBOARD_PO_PAST_URL
        data = {
          order,
          companyId: selectedCompany,
          warehouseId: selectedWarehouse,
          timeZoneOffSet: timeZone,
        };
      } else {
        data = {
          start_date: fromDate,
          end_date: toDate,
          companyId: selectedCompany,
          warehouseId: selectedWarehouse,
        };
      }
    } 
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: data,
    }).then((response) => {
      dispatch(fetchTodaysIncomingOrdersSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchTodaysIncomingOrdersFailure(err));                     
      }
    });
  };
}

export function printPurchaseOrder(purchaseOrder_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PRINT_PURCHASE_ORDER });
    return axios.get(
      `${PURCHASE_ORDERS_URL}print/${purchaseOrder_id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        window.open(`data:application/pdf,${escape(response.data)}`);
        dispatch(printPurchaseOrderSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(printPurchaseOrderFailure(err));                       
        }
      });
  };
}

export function printPurchaseOrderSuccess(orders) {
  return {
    type: PRINT_PURCHASE_ORDER_SUCCESS,
    payload: orders,
  };
}

export function printPurchaseOrderFailure(error) {
  return {
    type: PRINT_PURCHASE_ORDER_FAILURE,
    payload: error,
  };
}

export function setPriceValues(FOBUnit, EstSale, Form) {
  // clearRemarks();
  return (dispatch) => {
    dispatch(change(Form, 'AllProd_FOBUnitPrice', FOBUnit));
    dispatch(change(Form, 'AllProd_EstSalePrice', EstSale));
  };
}

export function setDefaultVendorAddress(address, contact, Form) {
  return (dispatch) => {
    dispatch(change(Form, 'Pickup_VendorAddress_id', address));
    dispatch(change(Form, 'Pickup_VendorContact_id', contact));
  };
}

export function clearRemarks(Form) {
  return (dispatch) => {
    dispatch(change(Form, 'AllProd_Remark', ''));
    dispatch(change(Form, 'Remark', ''));
  };
}

export function setDefaults(Form, value) {
  return (dispatch) => {
    dispatch(change(Form, 'Deliver_Warehouse_id', value));
  };
}

export function setValue(Form, Field, Value) {
  return (dispatch) => {
    dispatch(change(Form, Field, Value));
  };
}

export function fetchPurchaseOrderPerformance() {
  return (dispatch) => {
    dispatch({ type: REQUEST_PURCHASE_ORDER_PERFORMANCE });
    return axios.get(
      PURCHASE_ORDER_PERFORMANCE_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPurchaseOrderPerformanceSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPurchaseOrderPerformanceFailure(err));                       
        }
      });
  };
}

export function fetchPurchaseOrderPerformanceSuccess(data) {
  return {
    type: FETCH_PURCHASE_ORDER_PERFORMANCE_SUCCESS,
    payload: data,
  };
}

export function fetchPurchaseOrderPerformanceFailure(error) {
  return {
    type: FETCH_PURCHASE_ORDER_PERFORMANCE_FAILURE,
    payload: error,
  };
}

export function fetchPurchaseManagerInfo() {
  return (dispatch) => {
    dispatch({ type: REQUEST_PURCHASE_MANAGER_INFO });
    return axios.get(
      PURCHASE_MANAGER_INFO_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPurchaseManagerInfoSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPurchaseManagerInfoFailure(err));                       
        }
      });
  };
}

export function fetchPurchaseManagerInfoSuccess(info) {
  return {
    type: FETCH_PURCHASE_MANAGER_INFO_SUCCESS,
    payload: info,
  };
}

export function fetchPurchaseManagerInfoFailure(error) {
  return {
    type: FETCH_PURCHASE_MANAGER_INFO_FAILURE,
    payload: error,
  };
}

export function fetchMonthPerformance() {
  return (dispatch) => {
    dispatch({ type: REQUEST_LAST_MONTH_PERFORMANCE });
    return axios.get(
      LAST_MONTH_PERFORMANCE_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchMonthPerformanceSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchMonthPerformanceFailure(err));                       
        }
      });
  };
}

export function fetchMonthPerformanceSuccess(data) {
  return {
    type: FETCH_LAST_MONTH_PERFORMANCE_SUCCESS,
    payload: data,
  };
}

export function fetchMonthPerformanceFailure(error) {
  return {
    type: FETCH_LAST_MONTH_PERFORMANCE_FAILURE,
    payload: error,
  };
}

export function deletePurchaseOrder(purchaseOrder_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_DELETE_PURCHASE_ORDER });
    return axios.get(
      `${PURCHASE_ORDERS_URL + purchaseOrder_id}/cancel/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(deletePurchaseOrderSuccess());
        browserHistory.push('/purchaseOrder');
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(deletePurchaseOrderFailure(err));                       
        }
      });
  };
}

export function deletePurchaseOrderSuccess() {
  return {
    type: DELETE_PURCHASE_ORDER_SUCCESS,
  };
}

export function deletePurchaseOrderFailure(error) {
  return {
    type: DELETE_PURCHASE_ORDER_FAILURE,
    payload: error,
  };
}

export function fetchPurchasersPerformance() {
  return (dispatch) => {
    dispatch({ type: REQUEST_PURCHASERS_PERFORMANCE });
    return axios.get(
      `${LAST_MONTH_PERFORMANCE_URL}all/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPurchasersPerformanceSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPurchasersPerformanceFailure(err));                       
        }
      });
  };
}

export function fetchPurchasersPerformanceSuccess(records) {
  return {
    type: FETCH_PURCHASERS_PERFORMANCE_SUCCESS,
    payload: records,
  };
}

export function fetchPurchasersPerformanceFailure(error) {
  return {
    type: FETCH_PURCHASERS_PERFORMANCE_FAILURE,
    payload: error,
  };
}

export function fetchPresidentDashInfo() {
  return (dispatch) => {
    dispatch({ type: REQUEST_PRESIDENT_DASH_INFO });
    return axios.get(
      PRESIDENT_DASH_INFO_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPresidentDAshInfoSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPresidentDashInfoFailure(err));                       
        }
      });
  };
}

export function fetchPresidentDAshInfoSuccess(info) {
  return {
    type: FETCH_PRESIDENT_DASH_INFO_SUCCESS,
    payload: info,
  };
}

export function fetchPresidentDashInfoFailure(error) {
  return {
    type: FETCH_PRESIDENT_DASH_INFO_FAILURE,
    payload: error,
  };
}

export function fetchOverallPurchasePerformance(type) {
  const start_date = moment().toISOString();
  return (dispatch, getState) => {
    const state = getState();
    const selectedCompany = state.header.selectedCompany;
    dispatch({ type: REQUEST_OVERALL_PURCHASE_PERFORMANCE });
    let url = OVERALL_PURCHASE_PERFORMANCE_URL
    if (isGGI && selectedCompany) {
      url += `?company_id=${selectedCompany.value}`
    }
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: {
        type,
        start_date,
      },
    }).then((response) => {
      dispatch(fetchOverallPurchasePerformanceSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchOverallPurchasePerformanceFailure(err));                     
      }
    });
  };
}

export function fetchOverallPurchasePerformanceSuccess(data) {
  return {
    type: FETCH_OVERALL_PURCHASE_PERFORMANCE_SUCCESS,
    payload: data,
  };
}

export function fetchOverallPurchasePerformanceFailure(error) {
  return {
    type: FETCH_OVERALL_PURCHASE_PERFORMANCE_FAILURE,
    payload: error,
  };
}

export function fetchIncidentReport() {
  return (dispatch) => {
    dispatch({ type: REQUEST_INCIDENT_REPORT });
    return axios.get(
      INCIDENT_REPORT_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchIncidentReportSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchIncidentReportFailure(err));                       
        }
      });
  };
}

export function fetchIncidentReportSuccess(report) {
  return {
    type: FETCH_INCIDENT_REPORT_SUCCESS,
    payload: report,
  };
}

export function fetchIncidentReportFailure(error) {
  return {
    type: FETCH_INCIDENT_REPORT_FAILURE,
    payload: error,
  };
}

export function setAllProducts(product, Form) {
  return (dispatch) => {
    dispatch(change(Form, 'AllProducts', product));
  };
}

export function setDefaultSearchType(type, Form) {
  return (dispatch) => {
    dispatch(change(Form, 'searchType', type));
    dispatch(change(Form, 'AllProd_Quantity', 1));
  };
}

export function initializedPurchaseOrderForm(type, Form) {
  return (dispatch) => {
    dispatch(change(Form, 'searchType', type));
    dispatch(change(Form, 'AllProd_Quantity', 1));
  };
}

export function setDefaultIsDropship(type, Form) {
  return (dispatch) => { 
    dispatch(change(Form, 'IsDropship', type));
  };
}

export function setDefaultConvertItemPrice(type, Form) {
  return (dispatch) => {
    dispatch(change(Form, 'ConvertItemPrice', type));
  };
}

export function resetAllProducts(Form) {
  return (dispatch) => {
    dispatch(change(Form, 'AllProducts', ''));
    dispatch(change(Form, 'AllProd_Quantity', '1'));
    dispatch(change(Form, 'AllProd_FOBUnitPrice', ''));
    dispatch(change(Form, 'AllProd_EstSalePrice', ''));
    dispatch(change(Form, 'ProductInformation', ''));
    dispatch(change(Form, 'Quantity', 1));
    dispatch(change(Form, 'FOBUnitPrice', ''));
    dispatch(change(Form, 'EstSalePrice', ''));
    dispatch(change(Form, 'Weight', ''));
    dispatch(change(Form, 'AllProd_Remark', ''));
    dispatch(change(Form, 'RefSalePrice', ''));
  };
}

export const changeFormValue = (Form, field, value) => dispatch => dispatch(change(Form, field, value));
// export function setInitialForm(currentPurchaseOrderDetail, Form) {
//   return dispatch => {
//
//     dispatch(change(Form, 'Vendor_id', currentPurchaseOrderDetail.Vendor_id));
//     dispatch(change(Form, 'PurchaseOrder_id', currentPurchaseOrderDetail.PurchaseOrder_id));
//     dispatch(change(Form, 'OrderDate', currentPurchaseOrderDetail.OrderDate));
//     dispatch(change(Form, 'ETADate', currentPurchaseOrderDetail.ETADate));
//     dispatch(change(Form, 'ReceivedDate', currentPurchaseOrderDetail.ReceivedDate));
//     dispatch(change(Form, 'FinalNetWeight', currentPurchaseOrderDetail.FinalNetWeight));
//     dispatch(change(Form, 'FinalShippingWeight', currentPurchaseOrderDetail.FinalShippingWeight));
//     dispatch(change(Form, 'TotalPrice', currentPurchaseOrderDetail.TotalPrice));
//     dispatch(change(Form, 'NoteToVendor', currentPurchaseOrderDetail.NoteToVendor));
//     dispatch(change(Form, 'ReleaseInformation', currentPurchaseOrderDetail.ReleaseInformation));
//     dispatch(change(Form, 'CarryType', currentPurchaseOrderDetail.CarryType));
//     dispatch(change(Form, 'Discount', currentPurchaseOrderDetail.Discount));
//     dispatch(change(Form, 'ShippingCost', currentPurchaseOrderDetail.ShippingCost));
//     dispatch(change(Form, 'HandlingCost', currentPurchaseOrderDetail.HandlingCost));
//     dispatch(change(Form, 'MiscCost', currentPurchaseOrderDetail.MiscCost));
//     dispatch(change(Form, 'MiscNote', currentPurchaseOrderDetail.MiscNote));
//     dispatch(change(Form, 'PaymentStatus', currentPurchaseOrderDetail.PaymentStatus));
//     dispatch(change(Form, 'PaymentTerm_id', currentPurchaseOrderDetail.PaymentTerm_id));
//     dispatch(change(Form, 'PurchaseStatus', currentPurchaseOrderDetail.PurchaseStatus));
//     dispatch(change(Form, 'FinalPrice', currentPurchaseOrderDetail.FinalPrice));
//     dispatch(change(Form, 'ConvertItemPrice', currentPurchaseOrderDetail.ConvertItemPrice));
//     dispatch(change(Form, 'Pickup_VendorAddress_id', currentPurchaseOrderDetail.Pickup_VendorAddress_id));
//     dispatch(change(Form, 'Vendor_id', currentPurchaseOrderDetail.Vendor_id));
//     dispatch(change(Form, 'PurchaseOrder_id', currentPurchaseOrderDetail.PurchaseOrder_id));
//     dispatch(change(Form, 'Pickup_VendorContact_id', currentPurchaseOrderDetail.Pickup_VendorContact_id));
//     dispatch(change(Form, 'Deliver_Warehouse_id', currentPurchaseOrderDetail.Deliver_Warehouse_id));
//     dispatch(change(Form, 'DispatchMethod_id', currentPurchaseOrderDetail.DispatchMethod_id));
//     dispatch(change(Form, 'DispatchOutSourceContact_id', currentPurchaseOrderDetail.DispatchOutSourceContact_id));
//     dispatch(change(Form, 'Purchaser_User_id', currentPurchaseOrderDetail.Purchaser_User_id));
//     dispatch(change(Form, 'PurchaseOrder_id', currentPurchaseOrderDetail.PurchaseOrder_id));
//     dispatch(change(Form, 'Modifier_User_id', currentPurchaseOrderDetail.Modifier_User_id));
//     dispatch(change(Form, 'ShippingMethod', currentPurchaseOrderDetail.ShippingMethod));
//     dispatch(change(Form, 'IsDropship', currentPurchaseOrderDetail.IsDropship));
//     dispatch(change(Form, 'searchType', 'RefNum'));
//   }
// }

export function setDefaultDays(Form) {
  return (dispatch) => {
    dispatch(change(Form, 'Days', '7'));
  };
}

export function setDefaultOfForm(field, value, Form) {
  return (dispatch) => {
    dispatch(change(Form, field, value));
  };
}

export function changeFieldArrayOfForm(field, idx, value, Form) {
  return (dispatch) => {
    dispatch(arrayRemove(Form, field, idx));
    dispatch(arrayInsert(Form, field, idx, value));
  };
}

export function initializeForm(data, fields, Form) {
  return (dispatch) => {
    dispatch(initialize(Form, data, fields));
  };
}

export function fetchPurchaseOrderList(pk) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PURCHASE_ORDER_LIST });
    return axios.get(
      `${PURCHASE_ORDERS_URL}detail` + `/${pk}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPurchaseOrderListSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPurchaseOrderListFailure(err));                       
        }
      });
  };
}

export function fetchPurchaseOrderListSuccess(list) {
  return {
    type: FETCH_PURCHASE_ORDER_LIST_SUCCESS,
    payload: list,
  };
}

export function fetchPurchaseOrderListFailure(error) {
  return {
    type: FETCH_PURCHASE_ORDER_LIST_FAILURE,
    payload: error,
  };
}

export function setPurchaseOrdersFilter(data) {
  return {
    type: SET_PURCHASE_ORDERS_FILTER,
    payload: data,
  };
}

export function fetchPurchasingPerformance(days, fromDate, toDate, type, POStatus, Vendor_id) {
  const dates = toFromDates(days, fromDate, toDate);
  fromDate = `OrderDate__gte=${dates.fromDate}`;
  toDate = `OrderDate__lte=${dates.toDate}`;
  if (Vendor_id) {
    Vendor_id = Vendor_id.value || Vendor_id;
    Vendor_id = `${Vendor_id}/`;
  } else {
    Vendor_id = '';
  }
  if (POStatus) {
    POStatus = POStatus.value || POStatus;
    POStatus = `&PurchaseStatus=${POStatus}`;
  } else {
    POStatus = '&PurchaseStatus=All';
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_PURCHASING_PERFORMANCE });
    return axios.get(
      `${PURCHASE_URL}performance/Vendor_id/${Vendor_id}?${fromDate}&${toDate}${POStatus}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPurchasingPerformanceSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPurchasingPerformanceFailure(err));                       
        }
      });
  };
}

export function fetchPurchasingPerformanceSuccess(data) {
  return {
    type: FETCH_PURCHASING_PERFORMANCE_SUCCESS,
    payload: data,
  };
}

export function fetchPurchasingPerformanceFailure(error) {
  return {
    type: FETCH_PURCHASING_PERFORMANCE_FAILURE,
    payload: error,
  };
}

export function fetchPriceAdjustment(timeframe, { fromDate, toDate }) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PRICE_ADJUSTMENT });
    return axios({
      method: 'get',
      url: `${WAREHOUSES_URL}receiveprice/${timeframe}`,
      params: {
        start_time: fromDate,
        end_time: toDate,
      },
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((response) => {
        dispatch(fetchPriceAdjustmentSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPriceAdjustmentFailure(err));                       
        }
      });
  };
}

function fetchPriceAdjustmentSuccess(data) {
  return {
    type: FETCH_PRICE_ADJUSTMENT_SUCCESS,
    payload: data,
  };
}

function fetchPriceAdjustmentFailure(error) {
  return {
    type: FETCH_PRICE_ADJUSTMENT_FAILURE,
    payload: error,
  };
}

export function createPriceAdjustment(line) {
  return (dispatch) => {
    dispatch({ type: CREATE_PRICE_ADJUSTMENT });
    return axios.put(
      `${WAREHOUSES_URL}receiveprice/`,
      line,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(createPriceAdjustmentSuccess(response));
        browserHistory.push('/priceAdjustmentReport');
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(createPriceAdjustmentFailure(err));                       
        }
      });
  };
}

function createPriceAdjustmentSuccess(data) {
  return {
    type: CREATE_PRICE_ADJUSTMENT_SUCCESS,
    payload: data,
  };
}

function createPriceAdjustmentFailure(error) {
  return {
    type: CREATE_PRICE_ADJUSTMENT_FAILURE,
    payload: error,
  };
}

export function fetchPurchasePivotChartOrders(time) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PURCHASE_PIVOT_CHART_ORDERS });
    return axios.get(
      `${PURCHASE_URL}pivot/${time}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPurchasePivotChartOrdersSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPurchasePivotChartOrdersFailure(err));                       
        }
      });
  };
}

function fetchPurchasePivotChartOrdersSuccess(data) {
  return {
    type: FETCH_PURCHASE_PIVOT_CHART_ORDERS_SUCCESS,
    payload: data,
  };
}

function fetchPurchasePivotChartOrdersFailure(error) {
  return {
    type: FETCH_PURCHASE_PIVOT_CHART_ORDERS_FAILURE,
    payload: error,
  };
}

export function fetchPurchasePivotCharts(time) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PURCHASE_PIVOT_CHARTS });
    return axios.get(
      `${PURCHASE_URL}pivot/${time}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPurchasePivotChartsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPurchasePivotChartsFailure(err));                       
        }
      });
  };
}

function fetchPurchasePivotChartsSuccess(data) {
  return {
    type: FETCH_PURCHASE_PIVOT_CHARTS_SUCCESS,
    payload: data,
  };
}

function fetchPurchasePivotChartsFailure(error) {
  return {
    type: FETCH_PURCHASE_PIVOT_CHARTS_FAILURE,
    payload: error,
  };
}

export function fetchPurchasePivotChartsDetail(purchasePivot_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PURCHASE_PIVOT_CHARTS_DETAIL });
    return axios.get(
      `${PURCHASE_URL}pivot/${purchasePivot_id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPurchasePivotChartsDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPurchasePivotChartsDetailFailure(err));                       
        }
      });
  };
}

function fetchPurchasePivotChartsDetailSuccess(data) {
  return {
    type: FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_SUCCESS,
    payload: data,
  };
}

function fetchPurchasePivotChartsDetailFailure(error) {
  return {
    type: FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_FAILURE,
    payload: error,
  };
}

export function setPurchasePivotChart(PurchasePivot_id) {
  return {
    type: SET_PURCHASE_PIVOT_ID,
    payload: PurchasePivot_id,
  };
}

export function resetPurchasePivotCharts() {
  return {
    type: RESET_PURCHASE_PIVOT_CHARTS,
  };
}

export function createPurchasePivotChart(
  {
    PurchasePivot_id,
    Name,
    Description,
  },
  Vendors,
  Purchase_Pivot_Line,
) {
  return (dispatch) => {
    dispatch({ type: CREATE_PURCHASE_PIVOT_CHART });
    return axios.post(
      `${PURCHASE_URL}pivot/`,
      {
        PurchasePivot_id,
        Name,
        Description,
        Vendors,
        Purchase_Pivot_Line,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(createPurchasePivotChartSuccess(response));
        browserHistory.push('/purchasePivotChart');
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(createPurchasePivotChartFailure(err));                       
        }
      });
  };
}

function createPurchasePivotChartSuccess(data) {
  return {
    type: CREATE_PURCHASE_PIVOT_CHART_SUCCESS,
    payload: data,
  };
}

function createPurchasePivotChartFailure(error) {
  return {
    type: CREATE_PURCHASE_PIVOT_CHART_FAILURE,
    payload: error,
  };
}

export function duplicatePivotChart(PurchasePivot_id) {
  return (dispatch) => {
    dispatch({ type: DUPLICATE_PURCHASE_PIVOT_CHART });
    return axios.get(
      `${PURCHASE_URL}pivot/copy/${PurchasePivot_id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(duplicatePivotChartSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(duplicatePivotChartFailure(err));                       
        }
      });
  };
}

function duplicatePivotChartSuccess(data) {
  return {
    type: DUPLICATE_PURCHASE_PIVOT_CHART_SUCCESS,
    payload: data,
  };
}

function duplicatePivotChartFailure(error) {
  return {
    type: DUPLICATE_PURCHASE_PIVOT_CHART_FAILURE,
    payload: error,
  };
}

export function clearDuplicatedPurchasePivotChart() {
  return {
    type: CLEAR_DUPLICATED_PURCHASE_PIVOT_CHART,
  };
}

export function fetchPurchasingReference(type, typeRadios, group, category) {
  // if (group) {
  //   group = `ProductGroup_id=${group}`;
  // } else {
  //   group = '';
  // }
  // if (category) {
  //   category = `ProductCategory1_id=${category}`;
  // } else {
  //   category = '';
  // }
  const { toDate } = getFromToDates(moment());
  return (dispatch) => {
    dispatch({ type: REQUEST_PURCHASING_REFERENCE });
    return axios({
      method: 'get',
      url: `${PURCHASE_URL}referenceguide/${type}/${typeRadios}/`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: {
        ProductGroup_id: group,
        ProductCategory1_id: category,
        end_time: toDate,
      },
    }).then((response) => {
      dispatch(fetchPurchasingReferenceSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchPurchasingReferenceFailure(err));                     
      }
    });
  };
}

export function fetchPurchasingReferenceSuccess(data) {
  return {
    type: FETCH_PURCHASING_REFERENCE_SUCCESS,
    payload: data,
  };
}

export function fetchPurchasingReferenceFailure(error) {
  return {
    type: FETCH_PURCHASING_REFERENCE_FAILURE,
    payload: error,
  };
}

export function fetchPurchasePaymentNotPaid() {
  return (dispatch) => {
    dispatch(requestPurchasePaymentNotPaid());
    return axios.get(
      PURCHASE_ORDERS_NOT_RECEIVED_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPurchasePaymentNotPaidSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPurchasePaymentNotPaidFailure(err));                       
        }
      });
  };
}

export function requestPurchasePaymentNotPaid() {
  return {
    type: REQUEST_PURCHASE_PAYMENT_NOT_PAID,
  };
}

export function fetchPurchasePaymentNotPaidSuccess(purchaseOrders) {
  return {
    type: FETCH_PURCHASE_PAYMENT_NOT_PAID_SUCCESS,
    payload: purchaseOrders,
  };
}

export function fetchPurchasePaymentNotPaidFailure(error) {
  return {
    type: FETCH_PURCHASE_PAYMENT_NOT_PAID_FAILURE,
    payload: error,
  };
}

export function fetchPurchasingPerformanceByProduct(days, fromDate, toDate, type, POStatus, Product_id) {
  const date = getDateByDays(days, fromDate, toDate);
  fromDate = `OrderDate__gte=${date.fromDate}`;
  toDate = `OrderDate__lte=${date.toDate}`;
  if (Product_id) {
    Product_id = Product_id.value || Product_id;
    Product_id = parseInt(Product_id);
    Product_id += '/';
  } else {
    Product_id = '';
  }
  if (POStatus) {
    POStatus = POStatus.value || POStatus;
    POStatus = `&PurchaseStatus=${POStatus}`;
  } else {
    POStatus = '&PurchaseStatus=All';
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_PURCHASING_PERFORMANCE_BY_PRODUCT });
    return axios.get(
      `${PURCHASE_URL}performance/Product_id/${Product_id}?${fromDate}&${toDate}${POStatus}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPurchasingPerformanceByProductSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPurchasingPerformanceByProductFailure(err));                       
        }
      });
  };
}

export function fetchPurchasingPerformanceByProductSuccess(data) {
  return {
    type: FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_SUCCESS,
    payload: data,
  };
}

export function fetchPurchasingPerformanceByProductFailure(error) {
  return {
    type: FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_FAILURE,
    payload: error,
  };
}

function getDateByDays(days, fromDate, toDate) {
  let dateRange = -1;
  if (days != null) { dateRange = days; }
  const date = {
    fromDate: '',
    toDate: '',
  };
  let postingDateGT = fromDate || '1900-01-01';
  let postingDateLT = toDate || '3000-01-01';
  if (dateRange != -1) {
    postingDateLT = moment().format('YYYY-MM-DD');
    if (dateRange == '1') {
      postingDateGT = postingDateLT;
    } else if (dateRange == '7') {
      postingDateGT = moment().subtract('7', 'days').format('YYYY-MM-DD');
    } else if (dateRange == '30') {
      postingDateGT = moment().subtract('30', 'days').format('YYYY-MM-DD');
    } else if (dateRange == '90') {
      postingDateGT = moment().subtract('90', 'days').format('YYYY-MM-DD');
    }
  }
  date.fromDate = postingDateGT;
  date.toDate = postingDateLT;
  return date;
}

export function fetchPurchaseOrderProductByID(id) {
  return dispatch => axios.get(
    `${PURCHASE_ORDER_PRODUCT_BY_ID_URL}${id}`,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    },
  )
    .then((response) => {
      dispatch(fetchPurchaseOrderProductByIDSuccesful(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchPurchaseOrderProductByIDFailure(err));                     
      }
    });
}

export function fetchPurchaseOrderProductByIDSuccesful(product) {
  return {
    type: FETCH_PURCHASE_PRODUCT_BY_ID_SUCCESS,
    payload: product,
  };
}

export function fetchPurchaseOrderProductByIDFailure(error) {
  return {
    type: FETCH_PURCHASE_PRODUCT_BY_ID_FAILURE,
    payload: error,
  };
}

export function mergePurchaseOrders(orderIds) {
  return (dispatch) => {
    const config = {
      method: 'POST',
      url: MERGE_PURCHASE_ORDERS_API,
      data: {'orderIds': orderIds },
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    }
    dispatch(mergePurchaseOrdersLoading())
    axios(config)
    .then(res => {
      dispatch(mergePurchaseOrdersSuccess())
    }, (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(mergePurchaseOrdersError(err.data))                     
      }
    });
  }
}

export function mergePurchaseOrdersLoading() {
  return {
    type: MERGE_PURCHASE_ORDERS_LOADING
  }
}

export function mergePurchaseOrdersSuccess() {
  return {
    type: MERGE_PURCHASE_ORDERS_SUCCESS,
  }
}

export function mergePurchaseOrdersError(err) {
  return {
    type: MERGE_PURCHASE_ORDERS_ERROR,
    payload: err,
  }
}

export function approvePendingPO(ids) {
  const url = `${APPROVE_PENDING_PO_URL}`;
  return (dispatch) => {
    return axios({
      method: 'post',
      url: url,
      data: {purchaseOrders: ids},
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export const setDraftToOpen = (ids) => {
  const url = `${ROOT_URL_V2}purchase/draft_to_place/${ids}`;
  return (dispatch) => {
    return axios({
      method: 'post',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function emailPO(id) {
  return (dispatch) => {
    axios.get(
      `${ROOT_URL}v1/purchase/order/email/${id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      }
    )
      .then((response) => {
        alert(JSON.stringify(response.data));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          alert(JSON.stringify(err.data));                       
        }
      });
    };
}

export function emailPOPost(id, subject, content, email, phone, sendEmail, source, fromDate, toDate, cutoffDate) {
  let data = {subject, content};
  if (isEKC || isLMH || isSDR  || isCRW || isSV || isSC) {
    data = {subject, content, email};
  }
  if (isLAP) {
    data = {send_to: phone, subject: subject, content: content, email_to: sendEmail, source: source};
  }
  let url = ROOT_URL + 'v1/purchase/order/email/' + id;
  if (isLAP && source !== "CS") {
    url = ROOT_URL + 'v1/purchase/send_notification/' + id;
  }
  if (isLAP && source === "CS") {
    url = ROOT_URL + 'v1/purchase/send_notification/' + id + `?start_date=${fromDate}&end_date=${toDate}&cut_off_date=${cutoffDate}` ;
  }
  return (dispatch) => {
    axios.post(
      // `${ROOT_URL}v1/purchase/order/email/${id}`,
      url,
      // { subject, content },
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      }
    )
      .then((response) => {
        alert(JSON.stringify(response.data));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          alert(JSON.stringify(err.data));                       
        }
      });
    };
}

export function emailSelectedSalesInvoices(invoiceNum, data, success, failed) {
  axios.post(
    `${SALES_INVOICE_EMAIL_LAP}${invoiceNum}`,
    data,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    },
  )
    .then((res) => {
      if (res.error || res.status === 400 || res.status === 404) {
        failed(JSON.stringify(res.error));
        return;
      } else {
        success();
      }
    });
}

export const handlePoExportClick = (pks = [], success, failed) => axios.get(
    `${ROOT_URL}v1/purchase/search/poexport/${pks.join(',')}`,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      responseType: 'blob',
    }
  )
    .then((response) => {
      success(); 
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'PO_EXPORT.csv'); //or any other extension
      document.body.appendChild(link);
      link.click();
    }, (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        failed();                     
      }
    });

export const handlePOQuoteUpload = (data, success, failed, company, warehouse) => {
  axios({
    method: 'POST',
    url: `${ROOT_URL}v2/purchase/import_po_quote?warehouse_id=${warehouse.value}`,
    data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      // 'Content-Type': 'multipart/form-data'
    }
  })
    .then(res => {
      success();
    })
    .catch(err => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        failed(err);                     
      }
    })
}

export const handlePOUpload = (data, success, failed, company, warehouse) => dispatch => {
  axios({
    method: 'POST',
    url: `${ROOT_URL}v2/import_orders/?company_id=${company.value}&warehouse_id=${warehouse.value}`,
    data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      // 'Content-Type': 'multipart/form-data'
    }
  })
    .then(res => {
      success();
    })
    .catch(err => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        failed(err);                     
      }
    })
}


export function resetStatus(orderStatus, id, success, failed) {
  let url = '';
  if (orderStatus === 'factory') {
    url = PO_SET_TO_FACTORY_URL;
  } else if (orderStatus === 'port') {
    url = PO_SET_TO_PORT_URL;
  } else if (orderStatus === 'truck') {
    url = PO_SET_TO_TRUCK_URL;
  }
  return axios({
    method: 'put',
    url: `${url}${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then((response) => {
    success();
  }, (err) => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
    } else {
      failed(err);                   
    }
  });
}

export function printCode(autoCodes) {
  return (dispatch) => {
    let url = PURCHASE_LONGCODE_PRINT_URL;
    let config = {
      method:'POST',
      url,
      data:{ angle: 90, autoCodes: autoCodes },
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token')},
      responseType: 'blob',
    }
    axios(config)
    .then(res => {
      var a = document.createElement('a');
      a.target = '_blank'
      a.href =URL.createObjectURL(res.data); // 替换为你的PDF文件路径
      document.body.appendChild(a); 
      a.click(); 
      document.body.removeChild(a); 
    }, (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
      }
    })
  }
}



// WEBPACK FOOTER //
// ./master/jsx/actions/purchaseOrders_actions.js